import { render, staticRenderFns } from "./ReqTrasladoComponent.vue?vue&type=template&id=40c86764&scoped=true&"
import script from "./ReqTrasladoComponent.vue?vue&type=script&lang=js&"
export * from "./ReqTrasladoComponent.vue?vue&type=script&lang=js&"
import style0 from "./ReqTrasladoComponent.vue?vue&type=style&index=0&id=40c86764&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c86764",
  null
  
)

export default component.exports